var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUnderline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.486816 16.0349V14.9243H13.5127V16.0349H0.486816ZM6.99978 12.8725C5.4939 12.8725 4.3099 12.4361 3.44778 11.5634C2.58566 10.6906 2.1546 9.50437 2.1546 8.00477V0.0348663H3.61151V7.98593C3.61151 9.05763 3.9108 9.90972 4.50939 10.5422C5.10799 11.1747 5.93812 11.4909 6.99978 11.4909C8.06143 11.4909 8.89156 11.1747 9.49017 10.5422C10.0888 9.90972 10.388 9.05763 10.388 7.98593V0.0348663H11.845V8.00477C11.845 9.50437 11.4139 10.6906 10.5518 11.5634C9.68966 12.4361 8.50566 12.8725 6.99978 12.8725Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnderline);
export default __webpack_public_path__ + "static/media/iconUnderline.0fad1ac53f093405ea9da37a0a6c25e6.svg";
export { ForwardRef as ReactComponent };